export default __webpack_public_path__ + "static/media/crossout1.3e6004be.mp3";